<template>
  <div class="form-group">
    <h6>Lịch sử</h6>
    <b-table
      :busy.sync="loading"
      hover
      responsive
      :items="listHistoryTable"
      :fields="filterTable"
      :fixed="true"
      borderless
    >
      <template #table-busy>
        <div class="my-2 text-center">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template #cell(createByName)="data">
        <p>{{ data.item.createByName ?? '' }}</p>
      </template>
      <template #cell(createAt)="data">
        <p v-if="data.item.createAt">{{ data.item.createAt | formatDate('HH:mm, DD/MM/YYYY') }}</p>
      </template>
      <template #cell(action)="data">
        <p>{{ data.item.action ? joinArrayData(data.item.action, optionActionHistory) : '' }}</p>
      </template>
      <template #cell(note)="data">
        <p>{{ data.item.note ?? '' }}</p>
      </template>
    </b-table>
  </div>
</template>
<script>
  import { ContractService } from '@/services/contract.service'

  const fieldsTable = [
    { key: 'createByName', label: 'Người' },
    { key: 'createAt', label: 'Thời gian' },
    { key: 'action', label: 'Hành động' },
    { key: 'note', label: 'Ghi chú' },
  ]

  export default {
    data() {
      return {
        filterTable: fieldsTable,
        listHistoryTable: [],
        id: this.idRecord,
        loading: false,
        optionActionHistory: [
          { id: 'CREATE', text: 'Tạo mới' },
          { id: 'EDIT', text: 'Sửa' },
          { id: 'CANCELLED', text: 'Đã hủy' },
          { id: 'AWAITING_MANAGER_APPROVAL', text: 'Chờ giám đốc duyệt' },
          { id: 'MANAGER_APPROVED', text: 'GĐV duyệt, chờ vận hành duyệt' },
          { id: 'MANAGER_REJECTED', text: 'GĐV Từ chối' },
          { id: 'MANAGER_REQUESTED_ADDITIONAL_INFO', text: 'GĐV yêu cầu bổ sung' },
          { id: 'OPERATION_REQUESTED_EDIT', text: 'VH yêu cầu sửa đổi' },
          { id: 'OPERATION_PLEASE_ADVISE', text: 'VH xin ý kiến' },
          { id: 'OPERATION_APPROVED', text: 'VH đã duyệt' },
          { id: 'SA_ADDITIONAL_INFO_PROVIDED', text: 'SA Đã bổ sung hồ sơ' },
          { id: 'OPERATION_REFUSES_SUPPLEMENT_COMMIT', text: 'VH từ chối bổ sung theo cam kết' },
          { id: 'OPERATION_APPROVE_ADDITIONAL', text: 'VH duyệt bổ sung hồ sơ' },
          { id: 'OPERATION_REQUESTED_ADDITIONAL_INFO', text: 'VH yêu cầu bổ sung' },
        ],
      }
    },
    computed: {
      joinArrayData() {
        return (item, options) => {
          const mapData = options.find(e => e.id === item)
          return mapData ? mapData.text : ''
        }
      },
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
      async getListHistory() {
        try {
          this.loading = true
          const response = await ContractService.historyMerchantKeyOnus({
            id: this.id,
            sortBy: 'DESC',
            sortField: 'createAt',
          })
          if (response.success) {
            const mapData = response.data
            this.listHistoryTable = mapData.data ?? []
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.loading = false
        }
      },
      show(id) {
        if (id && id != '') {
          this.id = id
          this.getListHistory()
        }
      },
    },
  }
</script>
<style scoped></style>
